export default {"src":"/_next/static/media/curation_5.35849b13.gif","height":500,"width":550,"blurWidth":0,"blurHeight":0};